import React from 'react'

import { CaluRawSelect } from '../CaluRawSelect'

export const CaluSelect = (props) => {
  return <CaluRawSelect {...props} error={Boolean(props.error)} />
}
